export default {
    "stage": "prod",
    "apiUrl": "https://bookingapp-api.healthcasa.com/",
    "apiKey": "pyqxb1u6MH7V3JC6QV01B7RSQxpGm0ggavYa8XD5",
    "googleMapsApiKey": "AIzaSyAJHxqFYaeuZyBJJtI4eMFbzEzhgZxSw8I"
}